import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-wrapper2',
  templateUrl: './info-wrapper2.component.html',
  styleUrls: ['./info-wrapper2.component.scss']
})
export class InfoWrapper2Component implements OnInit {

  @Input() infpWrapper2Type:string;

  constructor() { }

  ngOnInit(): void {
  }

}
